import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { Grid, GridCell } from 'rmwc/Grid';
import {Toolbar, ToolbarRow, ToolbarSection, ToolbarMenuIcon, ToolbarTitle, ToolbarIcon} from 'rmwc';
import {
  Card,
  CardPrimaryAction,
  CardMedia,
  CardAction,
  CardActions,
  CardActionButtons,
  CardActionIcons
} from 'rmwc/Card';
import {Button} from 'rmwc/Button';

import { Typography } from 'rmwc/Typography';

import { BrowserRouter as Router, Route } from "react-router-dom";

let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

let energyItems = [];
energyItems.push({index: 3, value: "BTS 350 Ericsson", power: 500, voltage: 48, hours: 24,done: false});
energyItems.push({index: 2, value: "MW Dishes", power: 340, voltage: 48, hours: 24, done: true});
energyItems.push({index: 1, value: "Battery cabinet", power: 2000, voltage: 48, hours: 8, done: true});

class App extends Component {
  goTo(route) {
    this.props.history.replace(`/${route}`)
  }

  login() {
    this.props.auth.login();
  }

  logout() {
    this.props.auth.logout();
  }

  render() {
    const { isAuthenticated } = this.props.auth;

    return (
      <div>
        <Toolbar>
          <ToolbarRow>
            <ToolbarSection alignStart>
              <ToolbarMenuIcon use="menu" onClick={this.goTo.bind(this, 'home')}/>
              <ToolbarTitle>Solar Design Tool</ToolbarTitle>
            </ToolbarSection>
            <ToolbarSection alignEnd>
              {
                !isAuthenticated() && (
                  <ToolbarIcon use="account_circle" onClick={this.login.bind(this)}/>

                )
              }
              {
                isAuthenticated() && (
                  <ToolbarIcon use="exit_to_app" onClick={this.logout.bind(this)}/>

                )
              }
            </ToolbarSection>
          </ToolbarRow>
        </Toolbar>
      </div>

    );
  }
}






export default App;



// WEBPACK FOOTER //
// ./src/App.js